// src\app\ThemeProviderWrapper.tsx
'use client';

import { ThemeProvider } from '@mui/material/styles';
import { AppRouterCacheProvider } from '@mui/material-nextjs/v15-appRouter';
import CssBaseline from '@mui/material/CssBaseline';
import { ReactNode } from 'react';
import theme from './theme';

interface ThemeProviderWrapperProps {
  children: ReactNode;
}

export default function ThemeProviderWrapper({ children }: ThemeProviderWrapperProps) {
  return (
    <AppRouterCacheProvider
      options={{
        enableCssLayer: true,
        key: 'mui',
        prepend: true, // Insert MUI styles at the beginning for better CSS ordering
      }}
    >
      <ThemeProvider theme={theme}>
        <CssBaseline />
        {children}
      </ThemeProvider>
    </AppRouterCacheProvider>
  );
}